import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common';
import { EllipsisText } from '../../../composites/ellipsis-text/ellipsis-text';
import { sanitizeHtml } from '../../../common/render-html/sanitizer';
export var textKey = 'text';
export var TextColor;
(function (TextColor) {
    TextColor["t01"] = "#ffffff";
    TextColor["t10"] = "#000624";
    TextColor["t20"] = "#000624";
    TextColor["t30"] = "#333853";
    TextColor["t40"] = "#868aa5";
    TextColor["t50"] = "#acafc4";
    TextColor["t60"] = "#116dff";
    TextColor["t70"] = "#5999ff";
    TextColor["tg10"] = "#25a55a";
    TextColor["tr10"] = "#e62214";
    TextColor["to10"] = "#fb7d33";
})(TextColor || (TextColor = {}));
export var TypographyHeadingType;
(function (TypographyHeadingType) {
    TypographyHeadingType["hh"] = "hh";
    TypographyHeadingType["hxl"] = "hxl";
    TypographyHeadingType["hxll"] = "hxll";
    TypographyHeadingType["hl"] = "hl";
    TypographyHeadingType["hlm"] = "hlm";
    TypographyHeadingType["hll"] = "hll";
    TypographyHeadingType["hn"] = "hn";
    TypographyHeadingType["hnl"] = "hnl";
    TypographyHeadingType["hnm"] = "hnm";
    TypographyHeadingType["hs"] = "hs";
    TypographyHeadingType["hsl"] = "hsl";
    TypographyHeadingType["hsm"] = "hsm";
    TypographyHeadingType["hxs"] = "hxs";
    TypographyHeadingType["hxsm"] = "hxsm";
    TypographyHeadingType["hxsl"] = "hxsl";
    TypographyHeadingType["ht"] = "ht";
    TypographyHeadingType["htl"] = "htl";
    TypographyHeadingType["htm"] = "htm";
})(TypographyHeadingType || (TypographyHeadingType = {}));
export var TypographyTextType;
(function (TypographyTextType) {
    TypographyTextType["t"] = "t";
    TypographyTextType["tl"] = "tl";
    TypographyTextType["tm"] = "tm";
    TypographyTextType["ti"] = "ti";
    TypographyTextType["ts"] = "ts";
    TypographyTextType["tsl"] = "tsl";
    TypographyTextType["tsm"] = "tsm";
    TypographyTextType["tsmi"] = "tsmi";
    TypographyTextType["tsli"] = "tsli";
    TypographyTextType["tt"] = "tt";
    TypographyTextType["ttm"] = "ttm";
})(TypographyTextType || (TypographyTextType = {}));
var getTypographySemanticElement = function (type, useSpan) {
    switch (type) {
        case TypographyHeadingType.hh:
            return 'h2';
        case TypographyHeadingType.hxl:
        case TypographyHeadingType.hxll:
            return 'h3';
        case TypographyHeadingType.hl:
        case TypographyHeadingType.hlm:
        case TypographyHeadingType.hll:
        case TypographyHeadingType.hn:
        case TypographyHeadingType.hnm:
        case TypographyHeadingType.hnl:
            return 'h4';
        case TypographyHeadingType.hs:
        case TypographyHeadingType.hsl:
        case TypographyHeadingType.hsm:
            return 'h5';
        case TypographyHeadingType.hxs:
        case TypographyHeadingType.hxsm:
        case TypographyHeadingType.hxsl:
        case TypographyHeadingType.ht:
        case TypographyHeadingType.htl:
        case TypographyHeadingType.htm:
            return 'h6';
        default:
            return useSpan ? 'span' : 'div';
    }
};
var defaultProps = {
    type: 't',
    color: 't20'
};
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.render = function () {
        var _a;
        var props = __assign(__assign({}, defaultProps), this.props);
        var isClickable = props.onClick ? 'clickable' : '';
        // let useSpan = false;
        // try {
        // 	useSpan = typeof window !== 'undefined' && window.localStorage.getItem('__aex_textSpan') === 'true';
        // } catch (error) {
        // 	console.info('using div', error);
        // }
        // tslint:disable-next-line: no-object-literal-type-assertion
        var style = { '--var-color': "".concat(TextColor[props.color]) };
        var isHtml = !!props.html;
        var SemanticElement = !!isHtml ? 'div' : getTypographySemanticElement(props.type, props.useSpan);
        var usingSpan = SemanticElement === 'span';
        var cn = namespacedClassnames(textKey, props.type, isClickable, props.className, {
            ellipsis: usingSpan && props.ellipsis
        });
        var compProps = { className: cn, style: style, onClick: props.onClick };
        var maybeHtmlProps = props.html ? { dangerouslySetInnerHTML: { __html: sanitizeHtml(props.html) } } : {};
        var comp = isHtml ? (React.createElement(SemanticElement, __assign({}, compProps, maybeHtmlProps))) : (React.createElement(SemanticElement, __assign({}, compProps), props.children));
        var isChildrenString = typeof (props.children) === 'string';
        var elipsisText = isChildrenString ? props.children : undefined;
        var maybeEllipsisWrapper = (!isChildrenString && props.ellipsis && props.ellipsisWrapperClassName) || undefined;
        var tooltipBody = maybeEllipsisWrapper ?
            React.createElement("div", { className: "tooltip-body-".concat(maybeEllipsisWrapper) }, props.children) : undefined;
        var ellipsisTooltipCn = props.className ? (_a = props.className) === null || _a === void 0 ? void 0 : _a.split(' ').map(function (className) { return "".concat(className, "-ellipsis-tooltip"); }).join(' ') : '';
        var ellipsisComp = props.ellipsis && (React.createElement(EllipsisText, { direction: props.direction, tooltipText: elipsisText, tooltipRelativeToBody: props.relativeToBody, useSpan: usingSpan, className: ellipsisTooltipCn, tooltipBody: tooltipBody, ellipsisWrapperClassName: maybeEllipsisWrapper, maxRows: props.maxRows, noTooltip: props.noTooltip }, comp));
        return ellipsisComp || comp;
    };
    return Text;
}(React.PureComponent));
export { Text };
//# sourceMappingURL=index.js.map